<template>
  <label class="toggle-switch">
    <input
      type="checkbox"
      :checked="modelValue"
      @change="$emit('update:modelValue', $event.target.checked)"
      :disabled="disabled"
    />
    <span class="toggle-switch-slider"></span>
    <span class="toggle-switch-label"><slot></slot></span>
  </label>
</template>

<script>
export default {
  name: 'ToggleSwitch',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue']
}
</script>

<style scoped>
.toggle-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.toggle-switch input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-switch-slider {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  background-color: #ccc;
  border-radius: 24px;
  transition: background-color 0.2s;
  flex-shrink: 0;
}

.toggle-switch-slider::before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.2s;
}

.toggle-switch input:checked + .toggle-switch-slider {
  background-color: #3b3b3a;
}

.toggle-switch input:checked + .toggle-switch-slider::before {
  transform: translateX(20px);
}

.toggle-switch input:disabled + .toggle-switch-slider {
  opacity: 0.5;
  cursor: not-allowed;
}

.toggle-switch-label {
  margin-left: 10px;
  font-size: 0.875rem;
}
</style>
